import { post } from '@/utils/http'
import { postRequest } from '../../utils/request'
// 用户实名认证状态
export const sendRegisterSmsCode = function (data) {
    return post({
        url: "/oauth/sendRegisterSmsCode",
        data
    })
}

// 注册
export const codeRegister = function (data) {
    return post({
        url: "/oauth/codeRegister",
        data
    })
}

// 获取微信分享参数
export const shareConfig = function (data) {
    return post({
        url: "/oauth/inviteRegisterShareConfig",
        data
    })
}

// 获取微信分享参数
export const briefInfo = function (data) {
    return post({
        url: "/oauth/briefInfo",
        data
    })
}
// 获取邀请活动是否
export const getInfo2025 = function (data) {
    return postRequest({
        url: "/app/business/user/register/activit/config/getInfo2025",
        data
    })
}
// 收益排行榜 /app/business/user/register/activit/record/inviteTopList
export const inviteTopList = function (data) {
    return postRequest({
        url: "/app/business/user/register/activit/record/inviteTopList",
        data
    })
}
// 收益记录
export const recordList = function (data) {
    return postRequest({
        url: "/app/business/user/register/activit/record/list",
        data
    })
  }